export const KeyboardTemplate = {
  layouts: {
    search: {
      keyWidth: 70,
      keyHeight: 70,
      horizontalSpacing: 17,
      verticalSpacing: 20,
      fontFace: 'OpenSansRegular',
      fontSize: 30,
      lineHeight: 40,
      rows: [
        { keys: [{ c: 'A' }, { c: 'B' }, { c: 'C' }, { c: 'D' }, { c: 'E' }, { c: 'F' }] },
        { keys: [{ c: 'G' }, { c: 'H' }, { c: 'I' }, { c: 'J' }, { c: 'K' }, { c: 'L' }] },
        { keys: [{ c: 'M' }, { c: 'N' }, { c: 'O' }, { c: 'P' }, { c: 'Q' }, { c: 'R' }] },
        { keys: [{ c: 'S' }, { c: 'T' }, { c: 'U' }, { c: 'V' }, { c: 'W' }, { c: 'X' }] },
        {
          keys: [
            { c: 'Y' },
            { c: 'Z' },
            { action: 'toggleToLayout', toLayout: 'search!@#', c: '!@#' },
            { action: 'space', c: '___', tsKey: 'sp' },
            { action: 'toggleToLayout', toLayout: 'search123', c: '123' },
            { action: 'backspace', source: 'images/buttons/Backspace.png' },
          ],
        },
      ],
    },
    search123: {
      keyWidth: 70,
      keyHeight: 70,
      horizontalSpacing: 17,
      verticalSpacing: 20,
      fontFace: 'OpenSansRegular',
      fontSize: 30,
      lineHeight: 40,
      rows: [
        { keys: [{ c: '1' }, { c: '2' }, { c: '3' }, { c: '4' }, { c: '5' }, { c: '6' }] },
        { keys: [{ c: '7' }, { c: '8' }, { c: '9' }, { c: '0' }] },
        {
          rowVertOffset: 360,
          keys: [
            { action: 'toggleToLayout', keyHorOffset: 174, toLayout: 'search!@#', c: '!@#' },
            { action: 'space', c: '___', tsKey: 'sp' },
            { action: 'toggleToLayout', toLayout: 'search', c: 'ABC' },
            { action: 'backspace', source: 'images/buttons/Backspace.png' },
          ],
        },
      ],
    },
    'search!@#': {
      keyWidth: 70,
      keyHeight: 70,
      horizontalSpacing: 17,
      verticalSpacing: 20,
      fontFace: 'OpenSansRegular',
      fontSize: 30,
      lineHeight: 40,
      rows: [
        { keys: [{ c: '!' }, { c: '@' }, { c: '#' }, { c: '$' }, { c: '%' }, { c: '^' }] },
        { keys: [{ c: '&' }, { c: '*' }, { c: '(' }, { c: ')' }, { c: '-' }, { c: '+' }] },
        { keys: [{ c: '"' }, { c: "'" }, { c: '\\' }, { c: ',' }, { c: '?' }, { c: ':' }] },
        {
          rowVertOffset: 360,
          keys: [
            { action: 'toggleToLayout', keyHorOffset: 174, toLayout: 'search', c: 'ABC' },
            { action: 'space', c: '___', tsKey: 'sp' },
            { action: 'toggleToLayout', toLayout: 'search123', c: '123' },
            { action: 'backspace', source: 'images/buttons/Backspace.png' },
          ],
        },
      ],
    },
  },
}

export default KeyboardTemplate
